export const HISTORY_REPORT = 'https://dvschema.io/activation#ActivityReportStatusReport';
export const HISTORY_RESPONSE = 'https://dvschema.io/activation#ActivityReportStatusResponse';
export const REQUEST_HISTORY_REPORT = 'https://dvschema.io/activation#StatusReport';
export const FAILED_PAYLINK_REQUEST_ERROR = 'Failed to create paylink';
